export enum ShareStatus {
    'open' = 'open',
    'completed' = 'completed',
    'cancelled' = 'cancelled'
}
